<template>
  <div class="modalBooking">
    <div class="modalBooking -bg" @click="close"></div>
    <div class="modalBooking-content" v-if="showModal === 1">
      <img
        src="~@/assets/media/icons/close.svg"
        alt="close icon"
        @click="close"
        class="modalBooking-exit"
      />
      <div class="modalBooking-header">
        <h5>Choose a Space or Service</h5>
        <p>Click to view details and add to cart.</p>
      </div>
      <template v-if="data.locationId && data.categoryId">
        <Products
          v-if="progress === 'products'"
          :data="data"
          @next="handleChooseProduct"
        />
      </template>
      <ProductDetails
        v-if="progress === 'productDetails'"
        :productId="productId"
        :order="order"
        :orderIndex="orderIndex"
        @back="progress = 'products'"
        @next="submit"
      />
    </div>
    <div class="modalBooking-content" v-if="showModal === 2">
      <img
        src="~@/assets/media/icons/close.svg"
        alt="close icon"
        @click="close"
        class="modalBooking-exit"
      />
      <div class="p-20">
        <div class="row">
          <div class="col-12">
            <div class="text-center mt-30">
              <img src="@/assets/media/space.svg" alt="" />
              <h4 class="mt-30 mb-10">Space not Available</h4>
              <p class="font-size-md">
                Sorry, no coworking space is available for this location.
              </p>
              <ActionButton
                :theme="{ primary, secondary, event, danger }"
                label="Back to Booking"
                @customEvent="close"
                class="w-auto my-0 mx-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from "@/components/ActionButton";
import Products from "@/components/booking/Products";
import ProductDetails from "@/components/booking/ProductDetails";
import query from "@/api/query";
import axios from "@/helpers/axios";

export default {
  name: "ModalBooking",
  components: {
    Products,
    ProductDetails,
    ActionButton
  },
  props: ["data", "order", "orderIndex"],
  data() {
    return {
      progress: "products",
      productId: null,

      showModal: 0
    };
  },
  mounted() {
    if (this.order) {
      this.progress = this.order.progress;
      this.productId = this.order.Product.id;
      this.showModal = 1;
    } else {
      this.handleSpaceAvailability();
    }
  },
  methods: {
    handleStatus() {
      const status = this.$route.matched[0].name;
      switch (status) {
        case "user":
          return "&status=2";
        case "concierge":
        case "admin":
          return "&status=1";
      }
      return "";
    },
    async handleSpaceAvailability() {
      const status = this.handleStatus();
      const count = await axios
        .get(
          `/categories/${this.data.categoryId}/availableProducts?${status}&locationId=${this.data.locationId}`
        )
        .then(response => response.data.count);
      this.showModal = count > 0 ? 1 : 2;
    },
    close() {
      this.$emit("close");
    },
    async submit({ orderPackage, term }) {
      try {
        const product = await query
          .getSingleData({
            model: "products",
            id: this.productId
          })
          .then(response => response.data);
        if (product.data) {
          const schedule = {
            Product: product.data,
            Term: term,
            OrderPackage: orderPackage
          };
          this.$emit("submit", schedule);
        }
      } catch (error) {
        this.$toastr.error(
          "Something went wrong! Please contact administrator",
          "Oops!"
        );
      }
    },
    handleChooseProduct({ productId }) {
      this.progress = "productDetails";
      this.productId = productId;
    }
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  }
};
</script>

<style lang="scss" scoped>
.modalBooking {
  display: block;
  position: fixed;
  z-index: 1001;
  padding: 10px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  .-bg {
    background: black;
    content: "";
    opacity: 0.5;
    pointer-events: all;
    z-index: -1;
    height: 100%;
  }
  &-header {
    margin-bottom: 40px;
    h5 {
      color: #232323;
      font-size: $font-size-base;
      margin-bottom: 10px;
      position: relative;
    }
    p {
      font-size: $font-size-sm;
    }
  }
  @media (min-width: $screen-sm) {
    &-alert {
      height: 280px;
      width: 500px;
      margin: calc(50% - 140px) calc(50% - 250px) !important;
    }
  }
  @media (min-width: $screen-md) {
    &-alert {
      width: 680px;
      margin: calc(50vh - 250px) calc(50% - 340px) !important;
    }
  }
  &-alert {
    background-color: white;
    height: 400px;
    margin: calc(50vh - 200px) 0;
  }
  &-content {
    animation: fade-in-up 0.25s ease-out forwards;
    background-color: #fff;
    border-radius: 5px;
    left: 50%;
    max-height: 600px;
    overflow: auto;
    padding: 40px;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 800px;
    z-index: 1;
    @media (max-width: 800px) {
      width: 500px;
    }
    @media (max-width: 575px) {
      padding: 30px;
      width: calc(100% - 10px);
    }
  }
  &-exit {
    cursor: pointer;
    float: right;
    padding: 0;
    position: relative;
    z-index: 1;
  }
}

@keyframes fade-in-up {
  0% {
    opacity: 0;
    top: 44%;
  }
  100% {
    opacity: 1;
    top: 50%;
  }
}
</style>
